export default __webpack_public_path__ + "static/video2-9393408d46e77be90746bfe5b27e2bdb.mp4";